import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function EventsPage() {
  return <InstituteCrudPage config={entityConfigs['events']} />;
}
